import { EntityHistoryLedgerCard } from 'features/settings/history/components/DataGridHistoryCard';
import EntityHistory from 'features/dashboard/widgets/EntityHistory';
import toast from 'shared/utils/toast';
import { IEquipment } from '../../types';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { equipmentHistoryLineService, equipmentService } from 'shared/services';
import { EquipmentHistoryLineColumns } from '../../equipment-history-lines';

interface HistoryTabProps {
  equipment: IEquipment;
}

export const HistoryTab = ({ equipment }: HistoryTabProps) => {
  const { t } = useTranslation();

  const historyRefresher = useRef(null);

  const handleDateTimeUpdate = (id: number, datetime: string) => {
    equipmentHistoryLineService.update(id, { datetime: datetime }).then(() => {
      toast.success(t('actions.successfully.updated'));
      if (historyRefresher.current) {
        historyRefresher.current();
      }
    });
  };

  const handleDeleteLine = (id: number) => {
    equipmentHistoryLineService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      if (historyRefresher.current) {
        historyRefresher.current();
      }
    });
  };

  const manualRefresh = () => {
    if (historyRefresher.current) {
      historyRefresher.current();
    }
  };

  const historyColumns = EquipmentHistoryLineColumns(handleDateTimeUpdate, handleDeleteLine, false);

  return (
    <>
      <EntityHistoryLedgerCard
        service={equipmentHistoryLineService}
        columns={historyColumns}
        outerParams={{ equipment_code: equipment.code }}
        refreshTriggerRef={historyRefresher}
        onManualRefresh={manualRefresh}
      />

      <EntityHistory service={equipmentService} entityId={equipment.id} />
    </>
  );
};
